export class InvestigationLinkedInvestigationEntity {
  public id!: string;
  public linkedInvestigationId!: string;
  public linkedInvestigationNumber!: string;
  public linkedInvestigationTypeName!: string;
  public linkedInvestigationTypeCategoryName!: string;
  public linkedInvestigationStatusName!: string;
  public linkedInvestigationStatusColor!: string;
  public linkedInvestigationRequestorName!: string;
  public linkedInvestigationCreatedOn!: string;
  public linkType!: string;
  public isAutoLinked!: boolean;
}
